import {isTokenAlive} from "./service";

export async function getStat() {
    // await refreshAccessToken('eyJhbGciOiJIUzUxMiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI2NGViMTJhNy1mODA2LTQwMTktYTJlZC00ZWE1OTUxOWQ2YTYifQ.eyJleHAiOjE3MjU0NTI3NjIsImlhdCI6MTcyNTM2NjM2MiwianRpIjoiMTQxMThiNjgtM2U4OS00ODUyLTk3YzItNzZhOTlkZDAxMGJjIiwiaXNzIjoiaHR0cHM6Ly9rZXljbG9hay5yZWRpLnBhcnRuZXJzOjgwODEvcmVhbG1zL2FmZmh1YiIsImF1ZCI6Imh0dHBzOi8va2V5Y2xvYWsucmVkaS5wYXJ0bmVyczo4MDgxL3JlYWxtcy9hZmZodWIiLCJzdWIiOiJmOjBmN2RhM2NiLWNkNTctNDUxNy05MmFmLWJjYTcxMTgyZjY5OTptYWtzeW0udm92a0ByZWRpLnBhcnRuZXJzIiwidHlwIjoiUmVmcmVzaCIsImF6cCI6ImFmZmh1Yi1jbGllbnQiLCJzaWQiOiIzZGNhNzRmYi0xMTg3LTQxMzktOTk3NS1iOGY3NzI5ZTc2M2MiLCJzY29wZSI6InJvbGVzIGVtYWlsIHdlYi1vcmlnaW5zIGJhc2ljIGFjciBwcm9maWxlIn0.xO9eqBwvwiSctbH4UQQG1Oj7WhLd0XOigVj3Ilc7o0b4PCJvmb-q3sKm-Z_Ql0lX5SQFR64zV_p4C0nf2QaGcQ')

    try {
        const res = await fetch("https://tech.affhub.club/api/vote/get-stat")

        if (res.ok) {
            return await res.json()
        } else {
            console.log('error GET stats with code: ' + res.status)
        }
    } catch (e) {
        console.log('failed GET stats with error message: ' + e)
    }
}

export async function getUsersVotes(token) {
    // const access_token = await refreshAccessToken(token)

    const headers = new Headers()
    headers.append("Content-Type", "application/json")
    headers.append("Authorization", `Bearer ${token}`)

    const options = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
    };

    try {
        const res = await fetch("https://tech.affhub.club/api/vote/get-my-vote", options)

        if (res.ok) {
            return await res.json()
        } else {
            console.log('error GET users votes')
        }
    } catch (e) {
        console.log('failed GET users with error message: ' + e)
    }

}

export async function refreshAccessToken(accessToken) {
    const currentAccessToken = localStorage.getItem('auth')
    const currentRefreshToken = localStorage.getItem('refresh')
    const isCurrentAccessTokenAlive = isTokenAlive(currentAccessToken)
    console.log(isCurrentAccessTokenAlive);
    if (isCurrentAccessTokenAlive) {
        console.log('Access token is alive');
        return accessToken
    }

    const requestOptions = {
        method: "GET",
        redirect: "follow"
    };

    try {
        const res = await fetch(`https://tech.affhub.club/api/users/refresh-token?refreshToken=${currentRefreshToken}`, requestOptions)
        const { access_token, refresh_token } = await res.json()
        await localStorage.setItem('refresh', refresh_token)
        await localStorage.setItem('auth', access_token)
        return access_token

    } catch (e) {
        console.log('failed refreshing token', e)
    }
}

export async function regNewUser(data) {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
        redirect: 'follow'
    };

    try {
        const res = await fetch("https://tech.affhub.club/api/users/register", options)

        switch (res.status) {
            case 200: return await res.json()
            case 409: return {isRegistered: true}
        }

        if (res.ok) {
            console.log('success regUser')
            // return await res.json()
        } else {
            console.log('error regUser')
            // return res.status
        }
    } catch (e) {
        console.log('failed POST user', e)
    }
}

export async function loginUser(email) {
    const headers = new Headers();
    headers.append("Cookie", "JSESSIONID=F325369BC2B42B8010692A4B5A984C4A");

    const options = {
        method: 'POST',
        headers: headers,
        redirect: 'follow'
    };

    try {
        const res = await fetch(`https://tech.affhub.club/api/users/login?username=${email}`, options)

        if (res.ok) {
            console.log('success loginUser')
            return await res.json()
            // return await res.json()
        } else {
            console.log('error loginUser')
            // return res.status
        }
    } catch (e) {
        console.log('failed POST user', e)
    }
}

export async function obtainToken(email, otp) {
    const options = {
        method: 'POST',
        redirect: 'follow'
    };

    try {
        const res = await fetch(`https://tech.affhub.club/api/users/login-with-otp?username=${email}&otp=${otp}`, options)

        if (res.ok) {
            console.log('success obtainToken')
            return await res.json()
            // return await res.json()
        } else {
            console.log('error obtainToken')
            // return res.status
        }
    } catch (e) {
        console.log('failed POST user', e)
    }
}

export async function getPhoneVerifyStatus(token) {
    // const access_token = await refreshAccessToken(token)

    const headers = new Headers()
    headers.append("Authorization", `Bearer ${token}`);
    headers.append("Cookie", "JSESSIONID=FF2F64EBB8452233D18C429DE6D6E8CE");

    const options = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
    };

    try {
        const res = await fetch("https://tech.affhub.club/api/users/verify-phone", options)

        if (!res.ok) {
            throw new Error(`HTTP помилка! Статус: ${res.status}`);
        }

        return await res.json()

    } catch (error) {
        console.error('Сталася помилка під час запиту:', error.message);
    }
}

export async function sendPhoneVerifyCode(token) {
    // const access_token = await refreshAccessToken(token)

    const headers = new Headers()
    headers.append("Authorization", `Bearer ${token}`);
    headers.append("Cookie", "JSESSIONID=FF2F64EBB8452233D18C429DE6D6E8CE");

    const options = {
        method: 'POST',
        headers: headers,
        redirect: 'follow'
    };

    try {
        const res = await fetch("https://tech.affhub.club/api/users/send-code", options)

        if (!res.ok) {
            throw new Error(`HTTP помилка! Статус: ${res.status}`);
        }

        return await res.json()

    } catch (error) {
        console.error('Сталася помилка під час запиту:', error.message);
    }
}

export async function verifyPhoneNumber(token, otpCode) {
    // const access_token = await refreshAccessToken(token)

    var headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);
    headers.append("Cookie", "JSESSIONID=FF2F64EBB8452233D18C429DE6D6E8CE");

    const options = {
        method: 'POST',
        headers: headers,
        redirect: 'follow'
    };

    try {
        const res = await fetch(`https://tech.affhub.club/api/users/verify-code?phoneNumber=1111111111&code=${otpCode}`, options)

        if (!res.ok) {
            throw new Error(`HTTP помилка! Статус: ${res.status}`);
        }

        return await res

    } catch (error) {
        console.error('Сталася помилка під час запиту:', error.message);
    }
}

export async function createVote(data, token) {
    // const access_token = await refreshAccessToken(token)

    const headers = new Headers()
    headers.append("Content-Type", "application/json")
    headers.append("Authorization", `Bearer ${token}`)
    headers.append("Cookie", "JSESSIONID=FF2F64EBB8452233D18C429DE6D6E8CE")

    const options = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
        redirect: 'follow'
    };

    try {
        const res = await fetch("https://tech.affhub.club/api/vote/vote", options)

        if (!res.ok) {
            throw new Error(`HTTP помилка! Статус: ${res.status}`);
        }

        return await res.json()

    } catch (error) {
        console.error('Сталася помилка під час запиту:', error.message);
    }
}


